<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <LancarContratoModal
      v-if="showLancarContratoModal"
      :contratoId="contratoIdSelected"
      @closeModal="closeLancarContratoModal"
    />
    <LoadingData v-if="loadData" />
    <div v-else class="card">
      <div
        class="card-header d-flex justify-content-between align-items-center bg-transparent border-bottom"
      >
        <h5 class="card-title mb-0">Pré Lançamento</h5>
      </div>
      <div class="card-body">
        <ListPreLancamento
          :contratos="contratos"
          @lancarContrato="lancarEditContrato"
        />
      </div>
    </div>
  </Layout>
</template>

<script>
import { mapGetters } from 'vuex'
import Layout from '@/views/layouts/Layout.vue'
import PageHeader from '@/components/commons/PageHeader.vue'
import LoadingData from '@/components/commons/LoadingData.vue'
import LancarContratoModal from '@/components/financeiro/preLancamento/LancarContratoModal.vue'
import ListPreLancamento from '@/components/financeiro/preLancamento/ListPreLancamento.vue'

export default {
  name: 'PreLancamento',

  components: {
    Layout,
    PageHeader,
    LancarContratoModal,
    LoadingData,
    ListPreLancamento,
  },

  data() {
    return {
      title: 'Pré Lançamento',
      items: [
        {
          text: 'Lançar',
          active: true,
        },
      ],
      loadData: true,
      showLancarContratoModal: false,
      contratos: null,
      contratoIdSelected: null,
    }
  },

  computed: {
    ...mapGetters(['getModuleUserByCode']),
  },

  methods: {
    async getPreLancamento() {
      try {
        this.contratos = await this.$store.dispatch('getPreLancamento')
        this.loadData = false
      } catch (error) {
        if (error && error.message) {
          this.$root.$bvToast.toast(error.message, {
            title: 'Atenção!',
            variant: 'warning',
            solid: true,
          })
        } else {
          this.$root.$bvToast.toast(
            'Não foi possível se conectar ao servidor.',
            {
              title: 'Erro!',
              variant: 'danger',
              solid: true,
            },
          )
        }
      }
    },

    lancarEditContrato(contratoId) {
      this.contratoIdSelected = contratoId || null
      this.showLancarContratoModal = true
    },

    closeLancarContratoModal(loadListContratos) {
      if (loadListContratos) {
        this.getPreLancamento()
      }
      this.showLancarContratoModal = false
    },
  },

  mounted() {
    this.getPreLancamento()
  },
}
</script>
